import { z } from "zod";
// Slug format shared across skills, ambient context docs, task
// routers, and agent profiles. Mirrors
// Kept in sync with the control-plane authoring route validators.
export const authoringSlugSchema = z
    .string()
    .trim()
    .min(1)
    .max(80)
    .regex(/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/, "Slug must be lowercase alphanumeric with optional single hyphens");
export const authoringTenantSlugSchema = z.string().trim().min(1).max(120);
export const authoringCreatedBySchema = z.string().trim().min(1).max(120);
export const authoringVersionStatusSchema = z.enum([
    "draft",
    "published",
    "archived",
]);
export const authoringPersistedIdSchema = z.string().trim().min(1).max(120);
